import { useCallback } from "react";

export const useAutoFocus = (delay: number = 200, ref) => {
    return useCallback((elem) => {
        if (elem) {
            if (ref) ref.current = elem;
            setTimeout(() => {
                elem.focus();
            }, delay);
        }
    }, []);
};
